import { __assign } from "tslib";
import { createChatApi } from '.';
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder } from '../test-utils';
import { createHttpTestKit } from '../http/test-kit';
export var createChatApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createChatApi('', fakeHttp);
    var testKit = {
        whenStartChat: function (dto) {
            return createFakePostResponder(fakeHttp, '/chats')(dto);
        },
        whenJoinChat: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/new/" + dto.ticketId + "/join")(dto);
        },
        whenUpdateUser: function (dto) {
            return createFakePutResponder(fakeHttp, "/chats/" + dto.chatId + "/user")(dto);
        },
        whenGetParticipants: function (dto) {
            return createFakeGetResponder(fakeHttp, "/chats/" + dto.chatId + "/participants");
        },
        whenLeaveChat: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/new/" + dto.ticketId + "/leave")(dto);
        },
        whenEndChat: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/new/" + dto.ticketId + "/end")(dto);
        },
        whenAgentEndChat: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/new/" + dto.ticketId + "/agents/end")(dto);
        },
        whenGetStats: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/stats")(dto);
        },
        whenGetStatsExtended: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/stats/extended")(dto);
        },
        whenGetToken: function () {
            return createFakeGetResponder(fakeHttp, "/chats/token");
        },
        whenAddAgentReply: function (dto) {
            return createFakePostResponder(fakeHttp, "chats/new/" + dto.ticketId + "/agentMessage")(dto);
        },
        whenGetDashboardStats: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/stats/dashboard")(dto);
        },
        whenGetActiveAgents: function (dto) {
            return createFakePostResponder(fakeHttp, "/chats/agents/active")(dto);
        },
        whenUpdateChatMessage: function (dto) {
            return createFakePutResponder(fakeHttp, "/chats/new/" + dto.ticketId + "/messages/" + dto.messageId)(dto);
        },
        whenDeleteChatMessage: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/chats/new/" + dto.ticketId + "/messages/" + dto.messageId);
        },
        whenAcceptChatJob: function (dto) {
            return createFakePostResponder(fakeHttp, "/auto-assign/accept/chat")(dto);
        },
        whenDeclineChatJob: function (dto) {
            return createFakePostResponder(fakeHttp, "/auto-assign/decline")(dto);
        },
        whenStartOutboundChats: function (dto) {
            return createFakePostResponder(fakeHttp, '/chats/outbound')(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map